import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router'

import { BankReconciliationAccountSelect } from '@features/reconciliation/elements/BankReconciliationAccountSelect'
import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { queryClient } from '../../config/queryClient'
import { GlobalFiscalYearContextProvider } from '../../contexts/globalFiscalYearContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { EmberRoute } from '../../enums/emberRoute'

class BankAccountSelectWebComponent extends DOMModel {
  @byAttrVal organizationId: string
  @byAttrVal selectedAccountId: string
}

type BankAccountSelectModuleProps = {
  organizationId: string
  selectedAccountId: string
}

function BankAccountSelectModule({ organizationId, selectedAccountId }: BankAccountSelectModuleProps): ReactElement {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <CurrentUserContextProvider>
            <UserOrganizationContextProvider organizationId={organizationId}>
              <GlobalFiscalYearContextProvider organizationId={organizationId}>
                <BankReconciliationAccountSelect selectedId={selectedAccountId} route={EmberRoute.BankAccount} />
              </GlobalFiscalYearContextProvider>
            </UserOrganizationContextProvider>
          </CurrentUserContextProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const BankAccountSelectCustomElement = createCustomElement(
  BankAccountSelectModule,
  BankAccountSelectWebComponent,
  'element',
)

customElements.get('bank-account-select') ||
  customElements.define('bank-account-select', BankAccountSelectCustomElement)

export default BankAccountSelectCustomElement
